/* ==========================================================================
   PN 3.05 — Hızlı sepet (algılanan hız)
   Sorun (Clarity, 20.10.2026): ürün sayfasında "Sepete Ekle" tıklamalarının
   mobilde ~%18'i ölü. Ölçüm: /cart/add sunucu yanıtı 0,8–1,7 sn; çekmece
   ancak yanıt + bölüm çizimi bitince açılıyor (1,2–2,5 sn). Bu arada buton
   eski haline dönüyor, müşteri tekrar basıyor → tıklama boşa gidiyor.
   Çekmecedeki "+" (Adedi Artır) her basışta ~1,2 sn tüm satırları
   tıklanamaz yapıyor (pointer-events: none) → kademe indirimi için arka
   arkaya "+"ya basanların tıklamaları ölüyor.

   Ne yapar (temanın kendi dosyalarına dokunmadan, üstüne biner):
   1) Sepete Ekle'ye basıldığı AN çekmece açılır; en üstte ürün görseli ve
      "Sepete ekleniyor…" bandı görünür. Yanıt gelince bant "✓ Sepete
      eklendi" olur ve kendiliğinden kapanır. Hata olursa bant kapanır,
      tema hatayı butonun altında gösterir (eski davranış).
   2) Butonda başarı durumu: "✓ Sepete eklendi" (1,8 sn).
   3) Android'de kısa titreşim (dokunma onayı).
   4) Çekmece/sepet sayfasında adet "+/−" basışları artık kilitlenmez;
      eski (geç gelen) yanıtlar yenisinin üstüne yazmaz. Satır silme
      (adet 0) sırasında kilit korunur — satır sırası kaymasın diye.
   5) Clarity olayları: hizli_sepet_ekle, hizli_sepet_eklendi, hizli_sepet_hata.
   6) Aynı davranış koleksiyon/öneri kartlarındaki küçük "Sepete Ekle"
      (<add-to-cart>) ve hızlı bakış formu için de geçerli; ad ve görsel
      karttan okunur, kart butonu 1,8 sn yeşile döner.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__pnHizliSepet) return;
  window.__pnHizliSepet = true;

  var AYAR = window.shopSettings || {};
  if (!AYAR.cartDrawer) return;

  function olay(ad) {
    try { if (typeof window.clarity === 'function') window.clarity('event', ad); } catch (e) {}
  }

  function veriOku() {
    var el = document.getElementById('pn-hs-urun');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function kacis(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------------- bant ---------------- */
  var bant = null;          // { el, durum: 'bekliyor' | 'tamam' }
  var bantZamanlayici = null;
  var gozcu = null;

  function miniSepet() { return document.getElementById('mini-cart'); }

  function bantiYerlestir() {
    var mc = miniSepet();
    if (!mc || !bant) return;
    if (mc.contains(bant.el)) return;
    var ust = mc.querySelector('.mini-cart__header');
    if (ust && ust.parentNode) {
      ust.parentNode.insertBefore(bant.el, ust.nextSibling);
    } else {
      mc.insertBefore(bant.el, mc.firstChild);
    }
  }

  function gozcuyuKur() {
    var mc = miniSepet();
    if (!mc || gozcu) return;
    gozcu = new MutationObserver(function () {
      if (bant && !mc.contains(bant.el)) bantiYerlestir();
    });
    gozcu.observe(mc, { childList: true });
  }

  function bantGoster(bilgi) {
    clearTimeout(bantZamanlayici);
    var el = document.createElement('div');
    el.className = 'pn-hs-bant';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.innerHTML =
      (bilgi.gorsel ? '<img class="pn-hs-bant__gorsel" src="' + kacis(bilgi.gorsel) + '" alt="" width="52" height="52">' : '') +
      '<div class="pn-hs-bant__metin">' +
        (bilgi.ad ? '<p class="pn-hs-bant__ad">' + kacis(bilgi.ad) + '</p>' : '') +
        '<p class="pn-hs-bant__durum"><span class="pn-hs-bant__ikon" aria-hidden="true"></span><span data-pn-hs-durum>Sepete ekleniyor…</span></p>' +
      '</div>';
    if (bant && bant.el.parentNode) bant.el.parentNode.removeChild(bant.el);
    bant = { el: el, durum: 'bekliyor' };
    var mc = miniSepet();
    if (mc) mc.classList.add('pn-hs-bekliyor');
    gozcuyuKur();
    bantiYerlestir();
  }

  function bantTamam() {
    if (!bant) return;
    bant.durum = 'tamam';
    bant.el.classList.add('pn-hs-bant--tamam');
    var d = bant.el.querySelector('[data-pn-hs-durum]');
    if (d) d.textContent = 'Sepete eklendi';
    var mc = miniSepet();
    if (mc) mc.classList.remove('pn-hs-bekliyor');
    bantiYerlestir();
    clearTimeout(bantZamanlayici);
    bantZamanlayici = setTimeout(bantKaldir, 2600);
  }

  function bantKaldir() {
    clearTimeout(bantZamanlayici);
    var mc = miniSepet();
    if (mc) mc.classList.remove('pn-hs-bekliyor');
    if (!bant) return;
    var el = bant.el;
    bant = null;
    el.classList.add('pn-hs-bant--gidiyor');
    setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 260);
  }

  /* ---------------- buton ---------------- */
  var bekleyen = null;   // { buton, metin, zaman, zamanAsimi }

  function butonTamam(btn, eskiMetin, sadeceRenk) {
    if (!btn) return;
    btn.classList.add('pn-hs-eklendi');
    if (!sadeceRenk) btn.textContent = '✓ Sepete eklendi';
    setTimeout(function () {
      btn.classList.remove('pn-hs-eklendi');
      if (!sadeceRenk) btn.textContent = eskiMetin;
    }, 1800);
  }

  function bitir(basarili) {
    if (!bekleyen) return;
    var b = bekleyen;
    bekleyen = null;
    clearTimeout(b.zamanAsimi);
    if (basarili) {
      bantTamam();
      setTimeout(function () { butonTamam(b.buton, b.metin, b.sadeceRenk); }, 0);
      olay('hizli_sepet_eklendi');
    } else {
      bantKaldir();
      var cekmece = document.querySelector('cart-drawer');
      var detay = cekmece && cekmece.querySelector('details');
      if (b.cekmeceKapaliydi && detay && detay.hasAttribute('open') && typeof cekmece.closeMenuDrawer === 'function') {
        try { cekmece.closeMenuDrawer(); } catch (e) {}
      }
      olay('hizli_sepet_hata');
    }
  }

  /* Ürün adı + görseli sayfadan bul (koleksiyon kartı, hızlı bakış, öneriler) */
  function gorselBul(kap) {
    var img = kap && kap.querySelector('img');
    if (!img) return '';
    var src = img.currentSrc || img.getAttribute('src') || '';
    if (!src && img.getAttribute('srcset')) src = img.getAttribute('srcset').split(',')[0].trim().split(' ')[0];
    if (!src && img.dataset && img.dataset.src) src = img.dataset.src;
    return src;
  }

  function metin(el) {
    return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function sayfadanBilgi(kok) {
    var bilgi = { ad: '', gorsel: '' };
    if (!kok) return bilgi;
    var ad = kok.querySelector('.card__heading, .card-information__text, a.full-unstyled-link, .product__title h1, .product__title h2, .product__title a, h1, h2, h3');
    if (ad) {
      var ilk = ad.querySelector('a') || ad;
      bilgi.ad = metin(ilk);
    }
    var medya = kok.querySelector('.card__media, .product__media, .product__media-list, .media') || kok;
    bilgi.gorsel = gorselBul(medya);
    return bilgi;
  }

  /* Ortak başlangıç: çekmeceyi aç, bandı göster */
  function baslat(btn, bilgi, sadeceRenk) {
    var cekmece = document.querySelector('cart-drawer');
    var detay = cekmece && cekmece.querySelector('details');
    var kapaliydi = !(detay && detay.hasAttribute('open'));

    if (bekleyen) clearTimeout(bekleyen.zamanAsimi);
    bekleyen = {
      buton: btn,
      metin: btn.textContent.trim(),
      sadeceRenk: !!sadeceRenk,
      cekmeceKapaliydi: kapaliydi,
      zamanAsimi: setTimeout(function () { bitir(false); }, 12000)
    };

    try { if (navigator.vibrate) navigator.vibrate(12); } catch (err) {}

    bantGoster(bilgi);
    var mc = document.querySelector('mini-cart');
    if (mc && typeof mc.open === 'function') {
      try { mc.open(); } catch (err) {}
    }
    olay('hizli_sepet_ekle');
  }

  /* 1a) Ürün sayfası / hızlı bakış formu: temanın dinleyicisinden ÖNCE (yakalama evresi) */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.closest) return;
    var pf = form.closest('product-form');
    if (!pf) return;
    if (document.body.classList.contains('template-cart')) return;
    var btn = pf.querySelector('[type="submit"]');
    if (!btn || btn.classList.contains('loading') || btn.getAttribute('aria-disabled') === 'true') return;

    var veri = veriOku();
    var idAlani = form.querySelector('[name="id"]');
    var vId = idAlani ? String(idAlani.value) : '';
    var bilgi = { ad: '', gorsel: '' };
    var v = veri && veri.varyant && veri.varyant[vId];
    if (v) {
      bilgi.ad = veri.baslik || '';
      bilgi.gorsel = v.gorsel || veri.gorsel || '';
      if (v.ad && v.ad !== 'Default Title') bilgi.ad += ' — ' + v.ad;
    } else {
      bilgi = sayfadanBilgi(pf.closest('.quick-view__content, quick-view, .product, [id^="shopify-section"]'));
    }

    baslat(btn, bilgi, false);
  }, true);

  /* 1b) Koleksiyon / öneri kartlarındaki küçük "Sepete Ekle" (<add-to-cart>) */
  document.addEventListener('click', function (e) {
    var kart = e.target && e.target.closest && e.target.closest('add-to-cart');
    if (!kart || !kart.dataset.variantId) return;
    if (document.body.classList.contains('template-cart')) return;
    if (kart.classList.contains('loading') || kart.hasAttribute('disabled')) return;

    var bilgi = sayfadanBilgi(kart.closest('.card-wrapper, .card, .grid__item, li, .product-card'));
    baslat(kart, bilgi, true);
  }, true);

  /* Kart butonu hata verirse (ör. stok) tema bu olayı yayınlar */
  document.addEventListener('ajaxProduct:error', function () { bitir(false); });

  /* Başarı: tema yanıtı çekmeceye çizdiğinde */
  function yamaMiniCart() {
    var MC = customElements.get('mini-cart');
    if (!MC || MC.prototype.__pnHs) return !!MC;
    var asil = MC.prototype.renderContents;
    MC.prototype.renderContents = function () {
      var sonuc = asil.apply(this, arguments);
      bitir(true);
      return sonuc;
    };
    MC.prototype.__pnHs = true;
    return true;
  }

  /* Hata: tema hata mesajı gösterdiğinde */
  function yamaProductForm() {
    var PF = customElements.get('product-form');
    if (!PF || PF.prototype.__pnHs) return !!PF;
    var asil = PF.prototype.handleErrorMessage;
    PF.prototype.handleErrorMessage = function (mesaj) {
      var sonuc = asil.apply(this, arguments);
      if (mesaj) bitir(false);
      return sonuc;
    };
    PF.prototype.__pnHs = true;
    return true;
  }

  /* 4) Adet değişimi: kilitsiz + sıra korumalı */
  var sonIstek = 0;
  function yamaCartItems() {
    var CI = customElements.get('cart-items');
    if (!CI || CI.prototype.__pnHs) return !!CI;

    CI.prototype.updateQuantity = function (line, quantity, name) {
      var self = this;
      var sira = ++sonIstek;
      var silme = String(quantity) === '0';
      var kap = document.getElementById('main-cart-items');
      if (silme && kap) kap.classList.add('cart__items--disabled');

      var overlay = this.querySelectorAll('.loading-overlay')[line - 1];
      if (overlay) overlay.classList.remove('hidden');
      if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', false);

      var sections = this.getSectionsToRender().map(function (s) { return s.section; });
      var body = JSON.stringify({ line: line, quantity: quantity, sections: sections, sections_url: window.location.pathname });

      fetch(window.routes.cart_change_url, Object.assign({}, fetchConfig(), { body: body }))
        .then(function (r) { return r.text(); })
        .then(function (state) {
          if (sira !== sonIstek) return; // daha yeni bir istek var: eski yanıtı çizme
          var parsed = JSON.parse(state);
          self.classList.toggle('is-empty', parsed.item_count === 0);
          var footer = document.getElementById('main-cart-footer');
          if (footer) footer.classList.toggle('is-empty', parsed.item_count === 0);
          self.getSectionsToRender().forEach(function (section) {
            var element = document.getElementById(section.id);
            if (!element) return;
            var hedef = element.querySelector(section.selector) || element;
            if (hedef && parsed.sections && parsed.sections[section.section]) {
              hedef.innerHTML = self.getSectionInnerHTML(parsed.sections[section.section], section.selector);
            }
          });
          self.updateLiveRegions(line, parsed.item_count);
          var lineItem = document.getElementById('CartItem-' + line);
          if (lineItem && name) {
            var odak = lineItem.querySelector('[name="' + name + '"]');
            if (odak) { try { odak.focus({ preventScroll: true }); } catch (e) {} }
          }
          var k = document.getElementById('main-cart-items');
          if (k) k.classList.remove('cart__items--disabled');
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: state } }));
        })
        .catch(function () {
          if (sira !== sonIstek) return;
          self.querySelectorAll('.loading-overlay').forEach(function (o) { o.classList.add('hidden'); });
          var k = document.getElementById('main-cart-items');
          if (k) k.classList.remove('cart__items--disabled');
          if (self.cartErrors && window.cartStrings) self.cartErrors.textContent = window.cartStrings.error;
        });
    };
    CI.prototype.__pnHs = true;
    return true;
  }

  function hepsiniYamala() {
    var a = yamaMiniCart();
    var b = yamaProductForm();
    var c = yamaCartItems();
    return a && b && c;
  }

  if (!hepsiniYamala()) {
    ['mini-cart', 'product-form', 'cart-items'].forEach(function (ad) {
      if (!customElements.get(ad) && customElements.whenDefined) {
        customElements.whenDefined(ad).then(hepsiniYamala);
      }
    });
  }
})();
